import React, { Fragment, useContext } from 'react';
import FieldDisplay from 'field/display/FieldDisplay';
import LocaleContext from 'constants/localization';
import API from 'constants/api';

export default function AttachmentDisplay({field, defaultImage}) {
  return (
    <Fragment>
      {
        field.values.map((value, i) => (
          <div className={'mdrow'} key={i}>
            <Attachment value={value} defaultImage={defaultImage}/>
          </div>
        ))
      }
    </Fragment>
  );
}

const Attachment = ({value, defaultImage}) => {
  const LS = useContext(LocaleContext);
  const { uri, fields } = value;
  if (!fields) {
    return null;
  }

  const { fileName, mimeType, attachmentType, 
    primaryDocument, description, isIndexed, statementAttachment  } = fields;

  const ImagePreview = () => {
    let src = '';

    if (mimeType && mimeType.values[0].startsWith('image')) {
      src = `${API.DAM.DISPLAY_CONTENT}?uri=${uri}&type=thumb`;
    } else {
      src = defaultImage == null ? 'images/NoImage.jpg' : defaultImage;
    }
    return <img src={src} />;
  };

  return (
    <div className='resource digital-content flex-left attachmentDisplay'>
      <ImagePreview />
      <div style={{marginLeft: '2rem'}}>
        <p>
          <a className="downloadFileLink" style={{fontSize: '18px'}} target="_blank" 
            href={`${API.DAM.DISPLAY_ATTACHMENT}&uri=${uri}`}>
            {LS.downloadFile}
          </a>
        </p>
        <FieldDisplay field={fileName} />
        <FieldDisplay field={attachmentType} />
        <FieldDisplay field={primaryDocument} />
        <FieldDisplay field={description} />
        <FieldDisplay field={isIndexed} />
        <FieldDisplay field={statementAttachment} />
      </div>
    </div>
  );
};